<template slot="header" slot-scope="scope">
<div>
  <router-link to='/adminmanageadd'  class="sidebar-nav-link">
  <el-button  v-if="sso === false"  type="primary" icon="el-icon-circle-plus-outline">新增</el-button>
    </router-link>
  <span></span>
    <el-table :data="adminManage" style="width: 100%" max-height="1000">
    <el-table-column  prop="username" label="用户名" min-width="150">
    </el-table-column>
    <el-table-column prop="linkman" label="负责人" min-width="120">
    </el-table-column>
    <el-table-column prop="mobile" label="联系电话" min-width="120">
    </el-table-column>
      <el-table-column prop="dept" label="邮箱" min-width="120">
    </el-table-column>
      <el-table-column prop="adminType" label="管理员类型" min-width="120" :formatter="adminTypeFormat">
    </el-table-column>
    <el-table-column  label="操作"  v-if="sso === false" >
      <template slot-scope="scope" >

<router-link :to="{path:'/adminmanageupdate',query:{pid:scope.row.id,currentPage:currentPage}}"  class="sidebar-nav-link" >
        <el-button type="text" size="small">编辑</el-button>
          </router-link>
      </template>
    </el-table-column>

  </el-table>

</div>

</template>

<script>
import rootPathssb from '@/api/mainApi'
import { dataGetUrl } from '@/api/index'
export default {
  name: 'adminmanage',
  data () {
    return {
      sso: rootPathssb.sso,
      adminManage: [],
      eventIsstate: false,
      isState: '',
      delId: '',
      delIndex: '',
      eventsList: [],
      pageSize: 15,
      currentPage: 1,
      total: 0,
      pagenow: 1
    }
  },
  created () {
    var that = this
    console.log(this)
    dataGetUrl(rootPathssb.rootPath + '/admini/list').then(function (response) {
      console.log(response); console.log('bbb')
      that.adminManage = response.data.info
      that.checkSignin(response.data.result)
    }).catch(function (error) {
      console.log(error)
      console.log('aaa')
    })
  }, // 页面加载时
  methods: {
    getPageDate (event) {
      let that = this
      dataGetUrl(rootPathssb.rootPath + '/admini/list?pagenow=' + this.pagenow).then(function (response) {
        if (response.data.result === 1) {
          that.eventsList = response.data.info.list
          console.log('cg')
        };console.log(response.data)
      }).catch(function (error) {
        console.log(error); console.log(2222222222)
      })
    }, // 获取数据
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.pageSize = val// 获取page-sizes里的每页显示几条数据的值，赋给我们自定义的每页显示数量的变量pageNum
    }, // 每页个数变化
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.pagenow = val
      this.getPageDate()
    }, // 第几页
    handleprevclick (val) {
      this.currentPage = val - 1
      this.pagenow = val - 1
      this.getPageDate()
      console.log(this)
    }, // 上一页
    handlenextclick (val) {
      this.currentPage = val + 1
      this.pagenow = val + 1
      this.getPageDate()
    }, // 下一页
    adminTypeFormat (row, column) {
      if (row.adminType === '1') {
        return '超级管理员'
      } else {
        return '机构用户'
      }
    }, // 状态返回
    checkSignin (sta) {
      if (sta === -1) {
        window.location.href = '/signin'
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/adminmanage.vue